// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__25aFc","rootCenter":"LoadMoreObserver_rootCenter__2Tvx3","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__k0dKk"};